export default "__VITE_ASSET__ed255dc9__"